import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterPacket"
    ,pure: false
})
export class FilterPacket implements PipeTransform {
    transform(items : any[],filter:string) {
        if(!items || !filter){
            return items;
        }
        return items.filter((val,idx) => {
            if(val.dataHead.unitId.indexOf(filter) > -1){
                return true;
            }
            if(val.dataHead.dtgCarNo.indexOf(filter) > -1){
                return true;
            }
            return false;
        });
    }
}